const rePhoneNumber = /^\+[1-9][0-9]{1,14}$/

module.exports = function normalizePhoneNumber(input) {
  const match = rePhoneNumber.exec(input.replace(/[\s-]/g, ''))

  if (!match) return input

  return match[0]
}
